var appTitle = 'Singer Savvy'
var registerUserConfirmationMessage = 'Welcome to SingerSavvy! An Account Verfication link has been sent to your email. \r\nPlease confirm your account by clicking the link in the email.\r\n '
var activityTypesDefaults = [
  { text: 'Voice Lesson/Coaching', actId: '1' },
  { text: 'Teaching a Voice Lesson', actId: '2' },
  { text: 'Personal Practice', actId: '3' },
  { text: 'Talking', actId: '4' },
  { text: 'Talking Loudly/Party', actId: '5' },
  { text: 'Opera/Chamber', actId: '6' },
  { text: 'Choral Rehearsal', actId: '7' },
  { text: 'Solo Recital/Performance', actId: '38' },
  { text: 'Other', actId: '11' }
]
var activityIntensityTypesDefaults = [
  { index: '1', actId: '1', name: 'Light', value: 16 },
  { index: '2', actId: '1', name: 'Moderate', value: 24 },
  { index: '3', actId: '1', name: 'Extreme', value: 32 },
  { index: '4', actId: '2', name: 'Light', value: 16 },
  { index: '5', actId: '2', name: 'Moderate', value: 24 },
  { index: '6', actId: '2', name: 'Extreme', value: 32 },
  { index: '7', actId: '3', name: 'Light', value: 16 },
  { index: '8', actId: '3', name: 'Moderate', value: 24 },
  { index: '9', actId: '3', name: 'Extreme', value: 32 },
  { index: '10', actId: '4', name: 'Light', value: 20 },
  { index: '11', actId: '4', name: 'Moderate', value: 28 },
  { index: '12', actId: '4', name: 'Extreme', value: 36 },
  { index: '13', actId: '5', name: 'Light', value: 20 },
  { index: '14', actId: '5', name: 'Moderate', value: 28 },
  { index: '15', actId: '5', name: 'Extreme', value: 36 },
  { index: '16', actId: '6', name: 'Light', value: 16 },
  { index: '17', actId: '6', name: 'Moderate', value: 24 },
  { index: '18', actId: '6', name: 'Extreme', value: 32 },
  { index: '19', actId: '7', name: 'Light', value: 16 },
  { index: '20', actId: '7', name: 'Moderate', value: 24 },
  { index: '21', actId: '7', name: 'Extreme', value: 32 },
  { index: '22', actId: '38', name: 'Light', value: 40 },
  { index: '23', actId: '38', name: 'Moderate', value: 50 },
  { index: '24', actId: '38', name: 'Extreme', value: 60 },
  { index: '25', actId: '11', name: 'Light', value: 16 },
  { index: '26', actId: '11', name: 'Moderate', value: 24 },
  { index: '27', actId: '11', name: 'Extreme', value: 32 }
]

var activityDurationDefaults = [
  '15',
  '30',
  '45',
  '60',
  '75',
  '90',
  '105',
  '120',
  '135',
  '150',
  '165',
  '180',
  '195',
  '210',
  '225',
  '240'
]

var registerGoalsDefaults = [
  'Improve Vocal Health',
  'Maintain Vocal Health',
  'Use stats to determine factors having impact on Vocal Health',
  'Other'
]

var registerSingerTypeDefaults = [
  'Classical Singer',
  'Contemporary Commercial Music Singer',
  'Music Theater Singer',
  'Professional',
  'Public Speaker',
  'School Teacher',
  'Student',
  'Voice Teacher',
  'Other'
]

var registerGenderDefaults = [
  'Female',
  'Male',
  'Transgender - Male',
  'Transgender - Female',
  'Intersex',
  'Non-Binary'
]

var registerAgeDefaults = [
  '18-21',
  '22-24',
  '25-29',
  '30-34',
  '35-39',
  '40-44',
  '45-49',
  '50-54',
  '55-60',
  '60-70',
  '70-80',
  '80+'
]

var registerVoiceTypeDefaults = [
  'Soprano',
  'Mezzo-Soprano',
  'Contralto',
  'Counter-Tenor',
  'Tenor',
  'Baritone',
  'Bass-Baritone',
  'Bass'
]

var registerVoiceDescriptivesDefaults = [
  'Light',
  'Lyric',
  'Coloratura',
  'Belt',
  'Dramatic',
  'Spinto',
  'Helden'
]

var voiceFeelDefaults = [{
  index: 1,
  text: 'Very Poor',
  napValue: 1,
  btncolor: 'red',
  btnicon: 'sentiment_very_dissatisfied',
  minValue: 0,
  maxValue: 20
},
{
  index: 2,
  text: 'Poor',
  napValue: 1,
  btncolor: 'orange ',
  btnicon: 'sentiment_dissatisfied',
  minValue: 20,
  maxValue: 40
},
{
  index: 3,
  text: 'Fair',
  napValue: 2,
  btncolor: 'yellow darken-2',
  btnicon: 'sentiment_satisfied',
  minValue: 40,
  maxValue: 72
},
{
  index: 4,
  text: 'Good',
  napValue: 2,
  btncolor: 'light-green',
  btnicon: 'sentiment_satisfied_alt',
  minValue: 72,
  maxValue: 88
},
{
  index: 5,
  napValue: 3,
  text: 'Excellent',
  btncolor: 'green',
  btnicon: 'sentiment_very_satisfied',
  minValue: 88,
  maxValue: 100
}
]

var poolData = {
  UserPoolId: 'us-east-1_bdDq04No3', // Your user pool id here
  ClientId: '3gpl0plf6rprj66r2fd39oj9u1' // Your client id here
}

export default {
  activityIntensityTypesDefaults: activityIntensityTypesDefaults,
  activityTypesDefaults: activityTypesDefaults,
  registerVoiceDescriptivesDefaults: registerVoiceDescriptivesDefaults,
  registerVoiceTypeDefaults: registerVoiceTypeDefaults,
  registerAgeDefaults: registerAgeDefaults,
  registerGenderDefaults: registerGenderDefaults,
  registerSingerTypeDefaults: registerSingerTypeDefaults,
  registerGoalsDefaults: registerGoalsDefaults,
  appTitle: appTitle,
  poolData: poolData,
  registerUserConfirmationMessage: registerUserConfirmationMessage,
  activityDurationDefaults: activityDurationDefaults,
  voiceFeelDefaults: voiceFeelDefaults
}



// WEBPACK FOOTER //
// ./src/components/AppConst.js